<div class="layer-catalog">
    <kendo-tabstrip *ngIf="active" (tabSelect)="onTabSelect($event)">
        <kendo-tabstrip-tab [title]="'System Layers'" [selected]="true">
            <ng-template kendoTabContent>
                <ng-container *ngIf="filteredSystemLayerCatalogItems && !systemLayerErrorMessage">
                    <div class="form-group" [formGroup]="searchInputForm">
                        <div class="input-group filter-box">
                            <div class="input-container">
                                <input class="input-group-input form-control" type="text" formControlName="searchInput"
                                    placeholder="Filter by category name, layer name, or layer id."
                                    [(ngModel)]="searchText" />
                            </div>
                            <div class="icon-container">
                                <i class="icon-ui-filter"></i>
                            </div>
                        </div>
                    </div>
                    <div class="canvas">
                        <div *ngIf="loading.status">
                            <div class="loader is-active padding-leader-3 padding-trailer-3">
                                <div class="loader-bars"></div>
                                <div class="loader-text"> Loading...</div>
                            </div>
                        </div>
                        <ul class="list-plain layer-list" *ngIf="!loading.status">
                            <li class="clearfix" *ngFor="let catalogItem of filteredSystemLayerCatalogItems; trackBy:catalogTrack">
                                <mc-layer-catalog-item-ng [layerCatalogItem]="catalogItem" [layerItemType]="'System'"
                                                          [multiSelectActive]="false" (checkChangedEvent)="itemSelectedChanged($event)"></mc-layer-catalog-item-ng>
                            </li>
                        </ul>
                    </div>
                   
                    <div class="add-layers">
                        <button class="btn add-selected-layers" (click)="addSelectedLayers()"
                            [disabled]="!selectedLayers.length">Add Selected
                            Layers</button>
                        <button class="btn btn-clear cancel" (click)="layersAdded.emit(false)">Cancel</button>
                        <span class="layers-selected">
                            Layers Selected ({{ this.selectedLayers.length }})
                        </span>
                    </div>
                </ng-container>
                <ng-container *ngIf="systemLayerErrorMessage">
                    <div>
                        {{ systemLayerErrorMessage }}
                    </div>
                </ng-container>
            </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab [title]="'My Layers'" *ngIf="userId && showMyLayers">
            <ng-template kendoTabContent>
                <div *ngIf="userLayerNodes" [hidden]="showFolderEditor || showFolderPicker">
                    <div class="form-group" [formGroup]="searchInputForm">
                        <div class="input-group filter-box">
                            <div class="input-container">
                                <input class="input-group-input form-control" type="text" formControlName="searchInput"
                                       placeholder="Filter by category name, layer name, or layer id."
                                       [(ngModel)]="searchText" />
                            </div>
                            <div class="icon-container">
                                <i class="icon-ui-filter"></i>
                            </div>
                        </div>
                    </div>

                    <div class="clearfix new-folder">
                        <div class="pull-left">
                            <button class="btn btn-green" (click)="addFolder()">
                                <span class="icon-ui-plus"></span>&nbsp;New Folder
                            </button>
                        </div>
                    </div>

                    <div class="user-layer-list">
                        <div *ngIf="loading.status">
                            <div class="loader is-active padding-leader-3 padding-trailer-3">
                                <div class="loader-bars"></div>
                                <div class="loader-text">{{ loading.text }}</div>
                            </div>
                        </div>

                        <tree-root *ngIf="!loading.status" #userLayerTree [nodes]="userLayerNodes" [options]="treeOptions">
                            <ng-template #treeNodeTemplate let-node let-index="index">

                                <ng-container *ngIf="node.hasChildren || node.data.nodeType == 'group'">
                                    <span class="group-title">{{ node.data.name }}</span>
                                    <div class="pull-right folder-buttons">
                                        <button title="Edit Folder" type="button" class="btn btn-clear btn-small"
                                                (click)="editFolder(node.data)">
                                            <span class="icon-ui-edit" aria-hidden="true"></span>
                                        </button>
                                        <button title="Add Sub-Folder" type="button" class="btn btn-green btn-small"
                                                (click)="addFolder(node.data)">
                                            <span class="icon-ui-plus" aria-hidden="true"></span>
                                        </button>
                                        <button title="Delete Folder" type="button" class="btn btn-red btn-small"
                                                (click)="deleteFolder(node.data)">
                                            <span class="icon-ui-close-circled" aria-hidden="true"></span>
                                        </button>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="node.data.nodeType == 'leaf'">
                                    <mc-layer-catalog-item-ng [layerCatalogItem]="node.data" [layerItemType]="'System'"
                                                              [multiSelectActive]="false" (closeWindowEvent)="layersAdded.emit(false)"
                                                              (checkChangedEvent)="itemSelectedChanged($event)">
                                    </mc-layer-catalog-item-ng>
                                    <div class="pull-right folder-buttons">
                                        <button title="Move to Folder" type="button" class="btn btn-green btn-small"
                                                (click)="pickFolder(node.data)">
                                            <span class="icon-ui-right-arrow" aria-hidden="true"></span>
                                        </button>
                                        <button *ngIf="node.data.shareType !== 2" title="Share Layer" type="button" class="btn btn-green btn-small"
                                                (click)="shareLayer(node.data)">
                                            <span class="icon-ui-share" aria-hidden="true"></span>
                                        </button>
                                        <button *ngIf="node.data.shareType === 1" title="Unshare Layer" type="button" class="btn btn-red btn-small"
                                                (click)="unshareLayer(node.data)">
                                            <span class="icon-ui-user" aria-hidden="true"></span>
                                        </button>
                                        <button title="Delete Layer" type="button" class="btn btn-red btn-small"
                                                (click)="deleteLayer(node.data)">
                                            <span class="icon-ui-close-circled" aria-hidden="true"></span>
                                        </button>
                                    </div>
                                </ng-container>
                            </ng-template>
                        </tree-root>
                    </div>

                    <div class="add-layers">
                        <button class="btn" (click)="addSelectedLayers()"
                                [disabled]="!selectedLayers.length">
                            Add Selected Layers
                        </button>
                        <button class="btn" (click)="deleteSelectedLayers()"
                                [disabled]="!selectedLayers.length">
                            Delete Selected Layers
                        </button>
                        <button class="btn btn-clear cancel" (click)="layersAdded.emit(false)">Cancel</button>
                        <span class="layers-selected">
                            Layers Selected ({{ selectedLayers.length }})
                        </span>
                    </div>
                </div>

                <div class="folder-editor">
                    <h3 *ngIf="(showFolderEditor || showFolderPicker) && !loading.status">{{ !showFolderEditor && showFolderPicker ? 'Move to' : (folderEditing ? 'Edit' : 'Add') }} Folder</h3>
                    <div class="name-editor-container" *ngIf="showFolderEditor && !loading.status">
                        Folder Name:<input type="text" placeholder="Enter new folder name" [formControl]="newFolderName">
                        <div *ngIf="newFolderName.invalid && (newFolderName.dirty || newFolderName.touched)"
                             class="validation-message">
                            <div *ngIf="newFolderName.errors.required">Name is required</div>
                            <div *ngIf="newFolderName.errors.nameInUse">Name already exist</div>
                        </div>
                    </div>
                    <div class="folder-picker-container" *ngIf="(showFolderEditor || showFolderPicker) && !loading.status">
                        <label>
                            Parent Folder:
                            <select [(ngModel)]="parentFolderId">
                                <option *ngFor="let option of parentFolders" [ngValue]="option.id">
                                    {{ option.name }}
                                </option>
                            </select>
                        </label>
                    </div>
                    <div class="confirm-create-folder-container" *ngIf="showFolderEditor && !loading.status">
                        <button class="btn create-folder" (click)="newFolder()" [disabled]="newFolderName.invalid">Save</button>
                        <button class="btn btn-clear" (click)="createNewFolder = false; showFolderEditor = false;">Cancel</button>
                    </div>
                    <div class="confirm-change-folder-container" *ngIf="showFolderPicker && !loading.status">
                        <button class="btn change-folder" (click)="changeFolder()">Save</button>
                        <button class="btn btn-clear" (click)="showFolderPicker = false; showFolderEditor = false;">Cancel</button>
                    </div>

                    <div *ngIf="userMapErrorMessage">
                        {{ userMapErrorMessage }}
                    </div>
                </div>

                <ng-container *ngIf="systemLayerErrorMessage">
                    <div>
                        {{ systemLayerErrorMessage }}
                    </div>
                </ng-container>
            </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab [title]="'My Drawing Layers'" *ngIf="this.userId && showMyDrawingLayers">
            <ng-template kendoTabContent>
                <div *ngIf="drawLayerNodes" [hidden]="showFolderEditor || showFolderPicker">
                    <div class="form-group" [formGroup]="searchInputForm">
                        <div class="input-group filter-box">
                            <div class="input-container">
                                <input class="input-group-input form-control" type="text" formControlName="searchInput"
                                       placeholder="Filter by category name, layer name, or layer id."
                                       [(ngModel)]="searchText" />
                            </div>
                            <div class="icon-container">
                                <i class="icon-ui-filter"></i>
                            </div>
                        </div>
                    </div>

                    <div class="clearfix new-folder">
                        <div class="pull-left">
                            <button class="btn btn-green" (click)="addFolder()">
                                <span class="icon-ui-plus"></span>&nbsp;New Folder
                            </button>
                        </div>
                    </div>

                    <div class="user-layer-list">
                        <div *ngIf="loading.status">
                            <div class="loader is-active padding-leader-3 padding-trailer-3">
                                <div class="loader-bars"></div>
                                <div class="loader-text">{{ loading.text }}</div>
                            </div>
                        </div>

                        <tree-root *ngIf="!loading.status" #drawLayerTree [nodes]="drawLayerNodes" [options]="treeOptions">
                            <ng-template #treeNodeTemplate let-node let-index="index">

                                <ng-container *ngIf="node.hasChildren || node.data.nodeType == 'group'">
                                    <span class="group-title">{{ node.data.name }}</span>
                                    <div class="pull-right folder-buttons">
                                        <button title="Edit Folder" type="button" class="btn btn-clear btn-small"
                                                (click)="editFolder(node.data)">
                                            <span class="icon-ui-edit" aria-hidden="true"></span>
                                        </button>
                                        <button title="Add Sub-Folder" type="button" class="btn btn-green btn-small"
                                                (click)="addFolder(node.data)">
                                            <span class="icon-ui-plus" aria-hidden="true"></span>
                                        </button>
                                        <button title="Delete Folder" type="button" class="btn btn-red btn-small"
                                                (click)="deleteFolder(node.data)">
                                            <span class="icon-ui-close-circled" aria-hidden="true"></span>
                                        </button>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="node.data.nodeType == 'leaf'">
                                    <mc-layer-catalog-item-ng [layerCatalogItem]="node.data" [layerItemType]="'Draw'"
                                                              [multiSelectActive]="false" (closeWindowEvent)="layersAdded.emit(false)"
                                                              (checkChangedEvent)="itemSelectedChanged($event)">
                                    </mc-layer-catalog-item-ng>
                                    <div class="pull-right folder-buttons">
                                        <button title="Move to Folder" type="button" class="btn btn-green btn-small"
                                                (click)="pickFolder(node.data)">
                                            <span class="icon-ui-right-arrow" aria-hidden="true"></span>
                                        </button>
                                        <button *ngIf="node.data.shareType !== 2" title="Share Layer" type="button" class="btn btn-green btn-small"
                                                (click)="shareLayer(node.data)">
                                            <span class="icon-ui-share" aria-hidden="true"></span>
                                        </button>
                                        <button *ngIf="node.data.shareType === 1" title="Unshare Layer" type="button" class="btn btn-red btn-small"
                                                (click)="unshareLayer(node.data)">
                                            <span class="icon-ui-user" aria-hidden="true"></span>
                                        </button>
                                        <button title="Delete Layer" type="button" class="btn btn-red btn-small"
                                                (click)="deleteLayer(node.data)">
                                            <span class="icon-ui-close-circled" aria-hidden="true"></span>
                                        </button>
                                    </div>
                                </ng-container>
                            </ng-template>
                        </tree-root>
                    </div>

                    <div class="add-layers">
                        <button class="btn" (click)="addSelectedLayers()"
                                [disabled]="!selectedLayers.length">
                            Add Selected Layers
                        </button>
                        <button class="btn" (click)="deleteSelectedLayers()"
                                [disabled]="!selectedLayers.length">
                            Delete Selected layers
                        </button>
                        <button class="btn btn-clear cancel" (click)="layersAdded.emit(false)">Cancel</button>
                        <span class="layers-selected">
                            Layers Selected ({{ selectedLayers.length }})
                        </span>
                    </div>
                </div>

                <div class="folder-editor">
                    <h3 *ngIf="(showFolderEditor || showFolderPicker) && !loading.status">{{ !showFolderEditor && showFolderPicker ? 'Move to' : (folderEditing ? 'Edit' : 'Add') }} Folder</h3>
                    <div class="name-editor-container" *ngIf="showFolderEditor && !loading.status">
                        Folder Name:<input type="text" placeholder="Enter new folder name" [formControl]="newFolderName">
                        <div *ngIf="newFolderName.invalid && (newFolderName.dirty || newFolderName.touched)"
                             class="validation-message">
                            <div *ngIf="newFolderName.errors.required">Name is required</div>
                            <div *ngIf="newFolderName.errors.nameInUse">Name already exist</div>
                        </div>
                    </div>
                    <div class="folder-picker-container" *ngIf="(showFolderEditor || showFolderPicker) && !loading.status">
                        <label>
                            Parent Folder:
                            <select [(ngModel)]="parentFolderId">
                                <option *ngFor="let option of parentFolders" [ngValue]="option.id">
                                    {{ option.name }}
                                </option>
                            </select>
                        </label>
                    </div>
                    <div class="confirm-create-folder-container" *ngIf="showFolderEditor && !loading.status">
                        <button class="btn create-folder" (click)="newFolder()" [disabled]="newFolderName.invalid">Save</button>
                        <button class="btn btn-clear" (click)="createNewFolder = false; showFolderEditor = false;">Cancel</button>
                    </div>
                    <div class="confirm-change-folder-container" *ngIf="showFolderPicker && !loading.status">
                        <button class="btn change-folder" (click)="changeFolder()">Save</button>
                        <button class="btn btn-clear" (click)="showFolderPicker = false; showFolderEditor = false;">Cancel</button>
                    </div>
                    <div *ngIf="userMapErrorMessage">
                        {{ userMapErrorMessage }}
                    </div>
                </div>

                <ng-container *ngIf="systemLayerErrorMessage">
                    <div>
                        {{ systemLayerErrorMessage }}
                    </div>
                </ng-container>
            </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab [title]="externalLayerTabTitle" *ngIf="external" >
            <ng-template kendoTabContent>
                <ng-container>
                    <div style="position: relative;">
                        <mc-external-layer-catalog-ng #externalLayerCatalog (onclose)="layersAdded.emit(false)" [hidden]="!externalShowCatalog"></mc-external-layer-catalog-ng>
                        <button class="btn add" *ngIf="externalShowCatalog" (click)="externalShowCatalog = false">Add from URL or Shapefile</button>
                        <mc-add-external-layer-ng #addExternalLayer (onclose)="layersAdded.emit(false)" [hidden]="externalShowCatalog"></mc-add-external-layer-ng>
                        <button class="btn catalog" *ngIf="!externalShowCatalog" (click)="externalShowCatalog = true">Catalog</button>
                    </div>
                </ng-container>
            </ng-template>
        </kendo-tabstrip-tab>
    </kendo-tabstrip>
</div>
